import type { MarkAllReadResult, MyCommunity } from "@atrium/shared";
import { api, errorMessage } from "../../lib/api";
import { queryClient } from "../../lib/queryClient";
import { toast } from "../../components/ui/Toast";

/** POST /api/read-all, then clear unread state in the cache. */
export async function markAllRead() {
  try {
    const r = await api.post<MarkAllReadResult>("/api/read-all");
    queryClient.setQueryData(["unread"], { notifications: 0, conversations: 0 });
    queryClient.setQueryData<MyCommunity[]>(["my-communities"], (old) => old?.map((c) => ({ ...c, unread: false, mentionCount: 0 })));
    void queryClient.invalidateQueries({ queryKey: ["notifications"] });
    void queryClient.invalidateQueries({ queryKey: ["structure"] });
    void queryClient.invalidateQueries({ queryKey: ["conversations"] });
    const total = r.notifications + r.channels + r.conversations;
    toast.show(total ? "Everything is marked as read" : "Nothing unread");
  } catch (e) {
    toast.error(errorMessage(e, "Couldn't mark everything as read"));
  }
}

/** Focus the search box on /search once the (lazy) page has rendered. */
export function focusSearchInput(tries = 30) {
  const el = document.querySelector<HTMLInputElement>("input[data-global-search]");
  if (el) {
    el.focus();
    el.select();
  } else if (tries > 0) requestAnimationFrame(() => focusSearchInput(tries - 1));
}
